module.exports = __webpack_public_path__ + "media/npc_dota_hero_bristleback.9e68813a.webm";